<template>
    <div class="col col-12 pa-0 v-file-input">
        <v-row>
            <v-col cols="9" xl="8" v-if="schema && references" class="segmentation pa-3">
                <v-row class="pb-3">
                    <v-col cols="4">
                        <v-btn dense depressed color="primary"
                            @click="openSegmentDialogNew()">{{ $t('useExistingSegmentation') }}</v-btn>
                    </v-col>
                </v-row>
                <div v-for="(or, orIndex) in data" :key="'or_' + orIndex" class="or">
                    <v-chip small class="lightgrey operatorChip">
                        <span class="text-uppercase" v-if="orIndex == 0">{{ $t('if') }}</span>
                        <span class="text-uppercase" v-else>{{ $t('or') }}</span>
                    </v-chip>
                    <div class="divider">
                        <v-divider class="my-3"></v-divider>
                    </div>
                    <div v-for="(and, andIndex) in or" :key="'or_' + orIndex + 'and_' + andIndex" v-add-class-hover="'active'"
                        class="andDiv my-3 input-form">
                        <v-btn small text class="square removeBtn" @click="removeAnd(orIndex, andIndex)">
                            <v-icon small>
                                $minus_circle_l
                            </v-icon>
                        </v-btn>
                        <v-autocomplete solo flat hide-details dense :label="$t('field')"
                            @change="resetValues(orIndex, andIndex)" v-model="data[orIndex][andIndex].field"
                            :items="firstAutocomplete" item-value="value" item-text="name" class="field mx-3" :class="hasSelectFieldName(data[orIndex][andIndex].field) ? 'withSelectFieldName' : ''"
                            :no-data-text="$t('no-data-text')">
                        </v-autocomplete>

                        <div v-if="hasSelectFieldName(data[orIndex][andIndex].field)" class="field mx-3" :class="'withSelectFieldName'">
                            <v-autocomplete solo flat hide-details dense
                                @change="changeOperator(orIndex, andIndex)"
                                :label="$t(references[schema[data[orIndex][andIndex].field].fieldNames].label)"
                                v-model="data[orIndex][andIndex].fieldName"
                                :multiple="references[schema[data[orIndex][andIndex].field].fieldNames].multiple"
                                v-if="references[schema[data[orIndex][andIndex].field].fieldNames].type == 'autocomplete'"
                                :items="references[schema[data[orIndex][andIndex].field].fieldNames].content"
                                item-text="text"
                                item-value="value"
                                :no-data-text="$t('no-data-text')">
                            </v-autocomplete>
                        </div>

                        <v-select solo flat hide-details dense :label="$t('operator')"
                            @change="changeOperator(orIndex, andIndex)" :disabled="data[orIndex][andIndex].field == ''"
                            v-model="data[orIndex][andIndex].operator"
                            :items="schema[data[orIndex][andIndex].field] ? schema[data[orIndex][andIndex].field].operators : []"
                            item-text="value" item-value="value" return-object class="field mx-3" :class="hasSelectFieldName(data[orIndex][andIndex].field) ? 'withSelectFieldName' : ''"
                            :no-data-text="$t('no-data-text')">
                            <template slot="selection" slot-scope="data">
                                {{ $t(data.item.operatorLabel ? data.item.operatorLabel : data.item.value).toLowerCase() }}
                            </template>
                            <template slot="item" slot-scope="data">
                                {{ $t(data.item.operatorLabel ? data.item.operatorLabel : data.item.value).toLowerCase() }}
                            </template>
                        </v-select>

                        <v-text-field :label="$t('value')" solo flat class="field mx-3" :class="hasSelectFieldName(data[orIndex][andIndex].field) ? 'withSelectFieldName' : ''" hide-details dense disabled
                            v-if="data[orIndex][andIndex].field == '' || (data[orIndex][andIndex].operator == '' || Object.keys(data[orIndex][andIndex].operator).length == 0)"></v-text-field>
                        <div v-else class="field mx-3" :class="hasSelectFieldName(data[orIndex][andIndex].field) ? 'withSelectFieldName' : ''">
                            <v-select solo flat hide-details dense :label="$t(data[orIndex][andIndex].operator.label)"
                                @change="getDetailledStats" :disabled="data[orIndex][andIndex].operator == ''"
                                v-model="data[orIndex][andIndex].value"
                                :multiple="references[data[orIndex][andIndex].operator.ref].multiple"
                                v-if="data[orIndex][andIndex].field != '' && data[orIndex][andIndex].operator != '' && references[data[orIndex][andIndex].operator.ref] && references[data[orIndex][andIndex].operator.ref].type == 'select'"
                                :items="references[data[orIndex][andIndex].operator.ref].content" item-text="text"
                                item-value="value" :no-data-text="$t('no-data-text')">
                            </v-select>
                            <v-autocomplete solo flat hide-details dense
                                :label="model.source === 'PROFILIA' ? data[orIndex][andIndex].operator.label : $t(data[orIndex][andIndex].operator.label)"
                                :disabled="data[orIndex][andIndex].operator == ''"
                                v-model="data[orIndex][andIndex].value"
                                :multiple="references[data[orIndex][andIndex].operator.ref].multiple"
                                v-if="data[orIndex][andIndex].field != '' && data[orIndex][andIndex].operator != '' && references[data[orIndex][andIndex].operator.ref] && references[data[orIndex][andIndex].operator.ref].type == 'autocomplete'"
                                :items="references[data[orIndex][andIndex].operator.ref].content" item-text="text"
                                :item-value="data[orIndex][andIndex].category.includes('contactItems') ? 'text' : 'value'"
                                :no-data-text="$t('no-data-text')">
                            </v-autocomplete>
                            <v-combobox solo flat hide-details dense :label="$t(data[orIndex][andIndex].operator.label)"
                                @focus="loadComboboxEntries(data[orIndex][andIndex].value, data[orIndex][andIndex].field, data[orIndex][andIndex].operator.ref)"
                                @update:search-input="loadComboboxEntries($event, data[orIndex][andIndex].field, data[orIndex][andIndex].operator.ref)"
                                :disabled="data[orIndex][andIndex].operator == ''"
                                v-model="data[orIndex][andIndex].value"
                                :multiple="references[data[orIndex][andIndex].operator.ref].multiple"
                                v-if="data[orIndex][andIndex].field != '' && data[orIndex][andIndex].operator != '' && references[data[orIndex][andIndex].operator.ref] && references[data[orIndex][andIndex].operator.ref].type == 'combobox'"
                                :items="references[data[orIndex][andIndex].operator.ref].content" item-text="text"
                                :item-value="data[orIndex][andIndex].category.includes('contactItems') ? 'text' : 'value'"
                                :no-data-text="$t('no-data-text')">
                            </v-combobox>
                            <v-text-field solo flat hide-details dense type="number" min="0" @keydown="validateNumber"
                                :label="$t(data[orIndex][andIndex].operator.label)" required
                                :disabled="data[orIndex][andIndex].operator == ''"
                                v-model="data[orIndex][andIndex].value"
                                v-if="data[orIndex][andIndex].field != '' && data[orIndex][andIndex].operator != '' && references[data[orIndex][andIndex].operator.ref] && references[data[orIndex][andIndex].operator.ref].type == 'number'">
                            </v-text-field>
                            <span class="d-flex justify-space-between" v-if="data[orIndex][andIndex].field != '' && data[orIndex][andIndex].operator != '' && references[data[orIndex][andIndex].operator.ref] && references[data[orIndex][andIndex].operator.ref].type == 'numberBetween'">
                                <v-text-field solo flat hide-details dense type="number" min="0" @keydown="validateNumber"
                                    :label="$t('min')" required
                                    v-model="data[orIndex][andIndex].value[0]"
                                    style="width: 45%; margin-right: 12px;">
                                </v-text-field>
                                <v-text-field solo flat hide-details dense type="number" min="0" @keydown="validateNumber"
                                    :label="$t('max')" required
                                    v-model="data[orIndex][andIndex].value[1]"
                                    style="width: 45%; margin-left: 12px;">
                                </v-text-field>
                            </span>
                            <v-text-field solo flat hide-details dense type="text"
                                :label="model.source === 'PROFILIA' ? data[orIndex][andIndex].operator.label : $t(data[orIndex][andIndex].operator.label)" required
                                :disabled="data[orIndex][andIndex].operator == ''"
                                v-model="data[orIndex][andIndex].value"
                                v-if="data[orIndex][andIndex].field != '' && data[orIndex][andIndex].operator != '' && references[data[orIndex][andIndex].operator.ref] && references[data[orIndex][andIndex].operator.ref].type == 'text'"></v-text-field>
                            <v-menu v-model="data[orIndex][andIndex].menu" :close-on-content-click="false"
                                transition="scale-transition" offset-y max-width="290px" min-width="auto"
                                v-if="data[orIndex][andIndex].field != '' && data[orIndex][andIndex].operator != '' && references[data[orIndex][andIndex].operator.ref] && references[data[orIndex][andIndex].operator.ref].type == 'date'">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field solo flat hide-details dense @input="getDetailledStats"
                                        :label="$t(data[orIndex][andIndex].operator.label)" required readonly
                                        :disabled="data[orIndex][andIndex].operator == ''"
                                        v-model="data[orIndex][andIndex].value" append-icon="$calendar_alt_l"
                                        v-bind="attrs" v-on="on">
                                    </v-text-field>
                                </template>
                                <v-date-picker color="primary" v-model="data[orIndex][andIndex].value" no-title
                                    :first-day-of-week="1" :locale="$i18n.locale" :range="data[orIndex][andIndex].operator.value === 'dateBetween' ? true : false"
                                    @change="data[orIndex][andIndex].menu = false"></v-date-picker>
                            </v-menu>
                        </div>

                        <div
                            v-if="/rdv|demand|Items/.test(data[orIndex][andIndex].category) && schema[data[orIndex][andIndex].field] && schema[data[orIndex][andIndex].field].type === 'date'">
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-checkbox v-model="data[orIndex][andIndex].strict"
                                            @change="strictIsChanged(orIndex, andIndex)" hide-details
                                            class="strictCheckbox mt-0 pt-0"></v-checkbox>
                                    </span>
                                </template>
                                <span>{{ $t('segmentStrictCheckboxText') }}</span>
                            </v-tooltip>
                        </div>
                        <div v-else class="blank"></div>

                        <v-chip v-if="andIndex < (or.length - 1)" small class="lightgrey operatorChip text-uppercase">
                            {{ $t('and') }}
                        </v-chip>
                        <div v-else class="blank"></div>
                    </div>
                    <div class="addButton">
                        <div class="blank"></div>
                        <div class="field mx-3">
                            <v-btn depressed class="square" color="primary" @click="addAnd(orIndex)">
                                <v-icon>$plus_l</v-icon>
                            </v-btn>
                        </div>
                        <div class="field mx-3"></div>
                        <div class="blank"></div>
                        <div class="field mx-3 text-right">
                            <v-btn depressed text color="primary" @click="duplicate(orIndex)">
                                <v-icon small class="mr-2">$copy_l</v-icon> {{ $t('duplicate') }}
                            </v-btn>
                        </div>
                        <div class="blank"></div>
                    </div>
                </div>
                <div class="or">
                    <v-chip small class="lightgrey operatorChip">
                        <span class="text-uppercase" v-if="data.length > 0">{{ $t('or') }}</span>
                        <span class="text-uppercase" v-else>{{ $t('if') }}</span>
                    </v-chip>
                    <div class="divider">
                        <v-divider class="my-3"></v-divider>
                    </div>
                    <div class="addButton my-3">
                        <v-btn depressed class="square  mx-3" color="primary" @click="addOr">
                            <v-icon>$plus_l</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-col>
            <v-col cols="3" class="pa-3 px-6" v-if="model.source === 'PROFILIA'">
                <v-alert dense text color="primary" class="pa-4">
                    <div class="d-flex align-center">
                        <div>
                            <v-icon class="mr-4" color="primary" size="36">$users_d</v-icon>
                        </div>
                        <div>
                            <div class="mb-3">
                                {{ $t("eligible_contacts") }}
                                <infoTooltip :tooltip="{ title: 'eligible_contacts_title', description: 'eligible_contacts_description', color: 'primary' }" />
                            </div>
                            <div style="font-size: 32px; font-weight: 800;" v-if="realTime && Object.keys(realTime).length > 0">{{ realTime.number.toLocaleString() }}</div>
                            <div style="font-weight: 800;" v-else>{{ $t('noRulesDefined') }}</div>
                        </div>
                    </div>
                </v-alert>

                <v-alert dense text color="warning" class="pa-4 mt-4">
                    <div class="d-flex align-center">
                        <div>
                            <v-icon class="mr-4" color="warning" size="36">$filter_l</v-icon>
                        </div>
                        <div style="flex: 1;">
                            <div class="">{{ $t("max_contacts") }}</div>
                            <div class="d-flex align-center">
                                <v-slider
                                    v-model="model.maxContacts"
                                    :min="0"
                                    :max="realTime && Object.keys(realTime).length > 0 ? realTime.number : 1000"
                                    :step="1"
                                    thumb-label
                                    class="mr-3 align-center"
                                    hide-details
                                    @change="updateMaxContacts"
                                >
                                <template v-slot:append>
                                    <v-text-field
                                        v-model.number="model.maxContacts"
                                        type="number"
                                        :min="0"
                                        :max="realTime && Object.keys(realTime).length > 0 ? realTime.number : 1000"
                                        dense
                                        solo
                                        flat
                                        style="width: 90px;"
                                        hide-details
                                        single-line
                                        @input="updateMaxContacts"
                                    ></v-text-field>
                                </template>
                            </v-slider>
                            </div>
                        </div>
                    </div>
                </v-alert>

                <div v-if="isFromLibraryPage">
                    <div v-for="(value, index) in realTime.detail" :key="'detail_' + index" class="mt-4">
                        <div class="headingDetail">
                            <span class="primary--text">{{ $t(value.label) }}</span>
                            <span class="primary--text">{{ value.value }}/{{ realTime.number }}</span>
                        </div>
                        <v-progress-linear :value="getValue(value.value, realTime.number)"></v-progress-linear>
                    </div>
                </div>

                <v-alert v-else dense text color="success" class="pa-4">
                    <div class="d-flex align-center">
                        <div>
                            <v-icon class="mr-4" color="success" size="36">$sackdollar_d</v-icon>
                        </div>
                        <div>
                            <div class="mb-3">{{ $t("order_price") }}</div>
                            <div style="font-size: 32px; font-weight: 800;" v-if="realTime && Object.keys(realTime).length > 0">{{ realTime.price + ' €' }}</div>
                            <div style="font-weight: 800;" v-else>{{ $t('noRulesDefined') }}</div>
                        </div>
                    </div>
                </v-alert>
            </v-col>
            <v-col cols="3" class="pa-3 px-6" v-else>
                <v-card color="primary" rounded="lg">
                    <div v-if="realTime && Object.keys(realTime).length > 0" class="white--text realTimeNumbers">
                        <span class="number">{{ realTime.number }}</span>
                        <span class="text-uppercase"><b>{{ $t('contacts') }}</b>/{{ totalNumber }}</span>
                    </div>
                    <div class="white--text realTimeNumbers" v-else>
                        {{ $t('noRulesDefined') }}
                    </div>
                </v-card>
                <div v-if="realTime && Object.keys(realTime).length > 0">
                    <div v-for="(value, index) in realTime.detail" :key="'detail_' + index" class="mt-4">
                        <div class="headingDetail">
                            <span class="primary--text">{{ $t(value.label) }}</span>
                            <span class="primary--text">{{ value.value }}/{{ realTime.number }}</span>
                        </div>
                        <v-progress-linear :value="getValue(value.value, realTime.number)"></v-progress-linear>
                    </div>
                    <div style="height: 300px;" key="detail_entities" class="mt-4"
                        v-if="realTime.aggregations.entities.length != 0">
                        <div class="headingDetail">
                            <span class="primary--text">{{ $t('repartitionByEntity') }} :</span>
                        </div>
                        <div style="height:80%; display:flex; align-items:center; justify-content:space-between;">
                            <DonutComponent :key="donutKey" :dataSet="graphData" :legend="false" class="px-4"
                                style="height:100%; width:50%;" />
                            <div class="legend mr-6">
                                <div v-for="(legend, index) in labels('entities')" :key="'legend_' + index">
                                    <span
                                        :style="'width: 20px; height:10px; display:inline-block; background-color:' + backgroundRefs[index]"></span>
                                    {{ legend }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>

        <LibraryDialogComponent v-if="formLib" :form="formLib" :libType="libType" :pickerForm="true"
            @cancel="formLib = null;" @selectModel="selectModel" :showLibraryDialog="showLibraryDialog"
            @hideLibraryDialog="showLibraryDialog = false;" :isFromLibraryPage="isFromLibraryPage" :hideCreateWithoutModel="true" />
    </div>
</template>

<script>
import validate from "../functions/validations";
import GenericDataService from '@/services/GenericDataService';
import DonutComponent from '@/components/graphs/DonutComponent'
import infoTooltip from '@/components/infoTooltip'

export default {
    components: {},
    props: ["model", "fieldName", "field", "isFromLibraryPage"],
    components: {
        DonutComponent,
        infoTooltip,
        LibraryDialogComponent: () => import("@/components/dialogs/LibraryDialogComponent"),
        LibraryPreviewComponent: () => import("@/components/LibraryPreviewComponent"),
    },
    mixins: [validate],
    data() {
        return {
            segmentSegment: '0',
            formSegments: [],
            data: [],
            default_pool: [],
            schema: {},
            schemaTmp: {},
            references: {},
            firstAutocomplete: [],
            realTime: {},
            backgroundRefs: [
                "#2563EB", "#3B82F6", "#06B6D4", "#14B8A6", "#10B981",
                "#84CC16", "#FACC15", "#F59E0B", "#FB923C", "#F97316",
                "#EF4444", "#F43F5E", "#EC4899", "#A855F7", "#6366F1",
                "#C084FC", "#64748B", "#94A3B8", "#A5F3FC", "#86EFAC"
            ],
            donutKey: 0,
            totalNumber: 0,
            entity_id: null,
            forNoInitAtFirst: 0, // Dono ==> Rajouté ça car sinon à l'ouverture lors d'un edit liste de contacts ça appel 2 fois et si le premier répond après le deuxième alors les résultats sont faussés !
            showLibraryDialog: false,
            libType: "SEGMENT",
            formLib: null,
        }
    },
    created() {
        this.segmentSegment = this.model['id'] ? this.model['id'] : '0';
        this.data = this.model[this.fieldName] ? this.model[this.fieldName] : [];
        // Initialiser maxContacts s'il n'existe pas
        if (!this.model.maxContacts) {
            this.$set(this.model, 'maxContacts', 0);
        }
        this.loadSegment();
    },
    watch: {
        data: {
            handler(val) {
                this.model[this.fieldName] = val;
                if (this.forNoInitAtFirst === 0)
                    this.forNoInitAtFirst++;
                else
                    this.getDetailledStats(false)
            },
            deep: true
        },
        graphData(val) {
            this.donutKey++
        }
    },
    computed: {
        graphData() {
            let graphData = {}
            if (this.realTime && this.realTime.aggregations && this.realTime.aggregations['entities']) {
                graphData.datasets = [];
                let dataset = {};
                dataset.label = "";
                dataset.data = Object.values(this.realTime.aggregations['entities']).map(function (obj) { return obj.value });
                dataset.backgroundColor = this.backgroundRefs;
                graphData.datasets.push(dataset);
                graphData.labels = this.labels('entities');
            }

            return graphData;
        },
    },
    methods: {
        changeLabel() {
            let segment = this.formSegments.find((e) => e.value == this.segmentSegment)
        },
        loadSegment(forceSegmentUrl = false) {
            let getDetailledStats = false;
            if (this.segmentSegment !== '0') {
                let url = "";
                if (!forceSegmentUrl && this.field.contactlist)
                    url = "/contactlist/" + this.segmentSegment + "/get";
                else
                    url = "/segment/" + this.segmentSegment + "/get";
                GenericDataService.getData(url).then((response) => {
                    if (!forceSegmentUrl && this.field.contactlist) {
                        this.data = response.data.data.config;
                        this.default_pool = response.data.data.default_pool;
                        this.entity_id = response.data.data.entity_id.id;
                    } else
                        this.data = response.data.data.data;
                    this.segmentSegment = response.data.data.id
                    this.initSchema();
                })
            } else {
                this.initSchema();
                getDetailledStats = true;
            }
            this.initSelects();
            this.openSegmentDialog = false;
            GenericDataService.postData("/segment/try").then((response) => {
                this.totalNumber = response.data.data.totalNumber;
                if(getDetailledStats)
                    this.getDetailledStats();
            });
        },
        changeOperator: function (orIndex, andIndex) {
            if(this.data[orIndex][andIndex].operator.value === 'numberBetween' && typeof this.data[orIndex][andIndex].value !== 'object')
                this.data[orIndex][andIndex].value = [0, 0];

            if(this.data[orIndex][andIndex].operator.ref === 'numberField' && typeof this.data[orIndex][andIndex].value !== 'string')
                this.data[orIndex][andIndex].value = 0;

            if (this.schema[this.data[orIndex][andIndex].field].type === 'date') {
                let value = this.data[orIndex][andIndex].value;
                let operator = this.data[orIndex][andIndex].operator;

                if ((operator.ref == "dateField" && !value.includes("-")) || (operator.ref == "numberField" && value.includes("-")))
                    this.data[orIndex][andIndex].value = "";

                if(this.data[orIndex][andIndex].operator.value === 'dateBetween' && typeof this.data[orIndex][andIndex].value !== 'object')
                    this.data[orIndex][andIndex].value = [];
            }
            if ((this.data[orIndex][andIndex].value != '' && this.data[orIndex][andIndex].value.length > 0) || ['empty', 'notEmpty', 'valid', 'notValid', 'true', 'false', 'dateBeforeToday', 'dateAfterToday', 'dateEqualsToday'].includes(this.data[orIndex][andIndex].operator.value)) {
                this.changeLabel()
            }
        },
        resetValues: function (orIndex, andIndex) {
            for (let cat in this.schemaTmp) {
                if (this.schemaTmp[cat].hasOwnProperty(this.data[orIndex][andIndex].field)) {
                    this.data[orIndex][andIndex].category = cat;
                    break;
                }
            }

            this.data[orIndex][andIndex].operator = {};
            this.data[orIndex][andIndex].fieldName = null;
            this.data[orIndex][andIndex].value = "";
            this.data[orIndex][andIndex].strict = false;
            this.changeLabel();

            for (let index in this.data[orIndex]) {
                if (this.data[orIndex][index].category == this.data[orIndex][andIndex].category && this.schema[this.data[orIndex][index].field] && this.schema[this.data[orIndex][index].field].type === 'date') {
                    this.data[orIndex][andIndex].strict = this.data[orIndex][index].strict;
                }
            }
        },
        validateNumber(e) {
            if (['-', 'e', 'E', 'Dead', ',', '+', '.'].includes(e.key))
                e.preventDefault();
        },
        getDetailledStats: function (changeLabelParam = true) {
            let dataToSend = this._.cloneDeep(this.data)
            let filteredArray = [];
            dataToSend.forEach((orArray) => {
                let filteredOr = orArray.filter((e) => {
                    if(['dateBetween', 'numberBetween'].includes(e.operator.value)) {
                        return Array.isArray(e.value) && e.value.length === 2;
                    }

                    return (e.value && e.value != "" && e.value.length != 0) || ['empty', 'notEmpty', 'valid', 'notValid', 'true', 'false', 'dateBeforeToday', 'dateAfterToday', 'dateEqualsToday'].includes(e.operator.value);
                });
                if (filteredOr.length > 0) {
                    filteredArray.push(filteredOr)
                }
            });
            if (filteredArray.length) {
                if (this.field.contactlist) {
                    let pool = this._.cloneDeep(this.default_pool);
                    pool.push(filteredArray);

                    let url = "/segment/try?postDataIsPool=true&aggregations[]=entities";

                    if(this.model.source === 'PROFILIA')
                        url += "&source=PROFILIA&target=" + this.model.target; 

                    if(this.model.retroplanning_id)
                        url += "&retroplanning_id=" + this.model.retroplanning_id;

                    GenericDataService.postData(url, pool).then((response) => {
                        this.realTime = response.data.data;
                    });
                } else {
                    let url = "/segment/try?aggregations[]=entities";

                    if(this.model.source === 'PROFILIA')
                        url += "&source=PROFILIA&target=" + this.model.target; 

                    if(this.model.retroplanning_id)
                        url += "&retroplanning_id=" + this.model.retroplanning_id;

                    GenericDataService.postData(url, filteredArray).then((response) => {
                        this.realTime = response.data.data;
                    });
                }
            } else {
                this.realTime = {};
            }
            if (changeLabelParam) {
                this.changeLabel()
            }
        },
        initSelects: function () {
            GenericDataService.getData("/segment/_selectList").then((response) => {
                this.formSegments = [].concat.apply([{ 'value': '0', 'text': this.$t('newCustomSegment') }], response.data.data);
            });
        },
        async loadComboboxEntries(value, field, ref) {
            let url = this.references[ref].url.replace('{{field}}', field).replace('{{value}}', value ? value : '');
            if (this.entity_id)
                url += "&entity_id=" + this.entity_id;
            await GenericDataService.getData(url).then((response) => {
                this.references[ref].content = response.data.data;
            });
        },
        initSchema: function () {
            let url = "/segment/getSchema";

            if(this.model.source === 'PROFILIA')
                url += "&source=PROFILIA&target=" + this.model.target;

            // Passer l'id de l'entité associée à la liste de contacts si elle existe
            if(this.model.entity_id)
               url += "&entityId=" + this.model.entity_id;

            console.log(this.model.entity_id);
            GenericDataService.getData(url).then(async (response) => {
                let schemaTmp = response.data.data.schema;
                let references = response.data.data.references;
                for (var property in references) {
                    if (references[property].url && references[property].url !== "" && references[property].type !== "combobox") {
                        await GenericDataService.getData(references[property].url).then((response) => {
                            references[property].content = response.data.data;
                        });
                    }
                    if (references[property].to_trad && references[property].content) {
                        for (var content in references[property].content) {
                            references[property].content[content].text = this.$t(references[property].content[content].text);
                        }
                    }
                }

                // Permet d'afficher les OptGroups sur le premier autocomplete
                this.firstAutocomplete = [];
                this.schema = {};
                for (var groupName in schemaTmp) {
                    this.firstAutocomplete.push({ header: this.$t('schema_' + groupName) });
                    for (var value in schemaTmp[groupName]) {
                        let name = value.includes('customUser') ? ('Perso : ' + value.split('.')[value.split('.').length - 1]) : (schemaTmp[groupName][value].label ? schemaTmp[groupName][value].label : this.$t('schema_' + groupName + '_' + value));
                        this.firstAutocomplete.push({ name: name, value: value, group: groupName });

                        for (var operator in schemaTmp[groupName][value]) {
                            if (schemaTmp[groupName][value][operator]['header'])
                                schemaTmp[groupName][value][operator]['header'] = this.$t(schemaTmp[groupName][value][operator]['header']);

                            if(schemaTmp[groupName][value]['operators']){
                                schemaTmp[groupName][value]['operators'].forEach((operator) => {
                                    if(operator.header)
                                        operator.header = this.$t(operator.header);
                                });
                            }
                        }
                    }
                    this.schema = Object.assign(this.schema, schemaTmp[groupName]);
                }

                this.schemaTmp = schemaTmp;
                this.references = references;
            });
        },
        getValue: function (number, total) {
            return number === 0 ? 0 : Math.round((number * 100) / total);
        },
        addOr: function () {
            let item = { field: "", fieldName: "", operator: "", value: "", menu: 0, strict: false };
            this.data.push([item]);
            this.changeLabel();
        },
        addAnd: function (orIndex) {
            let item = { field: "", fieldName: "", operator: "", value: "", menu: 0, strict: false };
            this.data[orIndex].push(item);
            this.changeLabel();
        },
        removeAnd: function (orIndex, andIndex) {
            let orElement = this.data[orIndex];
            orElement.splice(andIndex, 1);
            if (orElement.length == 0) {
                this.data.splice(orIndex, 1);
            }
            this.changeLabel();
        },
        labels(type) {
            return Object.values(this.realTime.aggregations[type]).map(function (obj) { return obj.to_trad ? this.$t(obj.label) : obj.label; }, this);
        },
        duplicate(orIndex) {
            let duplicateData = this._.cloneDeep(this.data[orIndex]);
            this.data.push(duplicateData);
        },
        openSegmentDialogNew() {
            let url = "/library/getFilters?libType=" + this.libType;

            if(this.model.source === 'PROFILIA')
                url += "&params[source]=PROFILIA&params[target]=" + this.model.target;
            else
                url += "&params[source]=LEXXY";

            GenericDataService.getData(url).then((response) => {
                this.formLib = response.data.data;
                this.showLibraryDialog = true;
            });
        },
        selectModel(model) {
            this.segmentSegment = model.id;
            this.loadSegment(true);
        },
        strictIsChanged(orIndex, andIndex) {
            for (let index in this.data[orIndex]) {
                if (this.data[orIndex][index].category == this.data[orIndex][andIndex].category && this.schema[this.data[orIndex][index].field].type === 'date') {
                    this.data[orIndex][index].strict = this.data[orIndex][andIndex].strict;
                }
            }
        },
        hasSelectFieldName(field) {
            return field != '' && this.schema[field] && this.schema[field].fieldNames && this.references[this.schema[field].fieldNames];
        },
        updateMaxContacts() {
            // Valider et limiter la valeur au maximum autorisé
            if (!this.model.maxContacts || this.model.maxContacts === '' || this.model.maxContacts === null) {
                this.model.maxContacts = 0;
            }

            const maxValue = this.realTime.number;
            if (this.model.maxContacts > maxValue) {
                this.model.maxContacts = maxValue;
            }
            if (this.model.maxContacts < 0) {
                this.model.maxContacts = 0;
            }

            GenericDataService.postData("/entity/getEstimatedCostBilling?id=" + this.model.entity_id + "&canal=RENTAL&credit=" + this.model.maxContacts).then((response) => {
                this.realTime.price = parseFloat(response.data.data).toFixed(2);
            });
        }
    },
};
</script>

<style lang="scss">
.segmentation {
    border-right: 1px solid var(--v-mediumgrey-base) !important;
}

.or {
    position: relative;

}

.field {
    max-width: 28%;
    min-width: 28%;

    &.withSelectFieldName {
        max-width: 20.5% !important;
        min-width: 20.5% !important;
    }
}

.divider {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
    padding: 0 45px;
}

.operatorChip {
    border: 1px solid var(--v-mediumgrey-base) !important;
    z-index: 1;
    width: 45px;
    display: flex;
    justify-content: center;
}

.blank {
    width: 45px;
}

.removeBtn {
    min-width: 45px !important;
}

.addButton {
    //margin-left:45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.andDiv {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .removeBtn {
        opacity: 0;
    }

    &.active {
        .removeBtn {
            opacity: 1;
        }
    }
}

.realTimeNumbers {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;

    .number {
        font-size: 55px;
        line-height: 55px;
        font-weight: bold;
    }
}

.headingDetail {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.strictCheckbox {
    max-width: 45px;
    min-width: 45px;

    .v-input__slot {
        background-color: #FFF !important;
    }
}
</style>